import {
    CREATE_NEW_CATEGORY
} from '../../constants'
import { Category } from '../../../models'

export const createNewCategory = (data) => ({
    type: CREATE_NEW_CATEGORY,
    payload: new Category(data)
})